interface IScrollToItemParams {
  slideNode: HTMLElement;
  containerNode: HTMLElement;
  enableAnimation: boolean;
}

/**
 *
 * @description Прокручивает слайдер к заданому слайду.
 */
export function scrollToSlide(params: IScrollToItemParams) {
  const { slideNode, containerNode, enableAnimation } = params;

  const options = {
    left: slideNode.offsetLeft,
    behavior: enableAnimation ? 'smooth' : 'auto',
  } as const;

  containerNode.scroll?.(options);
}
